import { TRPC_ERROR_CODES_BY_KEY } from "@trpc/server/unstable-core-do-not-import";
import { isTRPCClientError } from "~/trpc/client";

export function parseError(error: Error): {
	code: number;
	message: string;
	title?: string;
} {
	if (isTRPCClientError(error)) {
		switch (error.data?.code) {
			case "UNAUTHORIZED":
				return {
					code: 401,
					message: "Not Authorized",
				};
			case "NOT_FOUND":
				return {
					code: 404,
					message: "Not Found",
				};
			case "UNPROCESSABLE_CONTENT":
				return {
					code: 422,
					message: "Validation Error",
				};
		}

		return {
			code: error.data?.httpStatus ?? 500,
			message: error.message ?? error.data?.code ?? "Server Error",
		};
	}

	return {
		code: 500,
		message: "An unknown error occurred.",
		title: "Unknown Error",
	};
}

export function parseValidationErrors<T>(error: unknown, defaultMessage: T) {
	if (
		isTRPCClientError(error) &&
		error.shape?.code === TRPC_ERROR_CODES_BY_KEY.UNPROCESSABLE_CONTENT &&
		"validation" in error.shape
	) {
		return error.shape.validation;
	}

	return defaultMessage;
}
